module.exports = __webpack_public_path__ + "media/images/emblems/Aarberg-coat_of_arms-bee281277e2585e574225a3ed2af66e1.svg";